import client from '../../sanity_client'
import {urlFor} from '../../sanity_image'
import Nav from '@/components/Nav';
import Footer from '@/components/Footer';
import FeaturedPosts from '@/components/posts/FeaturedPosts';
import Banner from '@/components/PageBanner';
import {toHTML} from '@portabletext/to-html';
import {useEffect} from "react";
import groq from 'groq';
import ContactForm from '@/components/ContactForm';

export default function Post({blogPageContent, post, featuredPosts, siteSettings}:any) {

  // this will move into the lib helper once we merge with dev branch
  function formatDateString(dateVal:any) {
    const date = new Date(dateVal);
    const options = { month: 'long', day: 'numeric', year: 'numeric' };
    // @ts-ignore
    const retDate = date.toLocaleDateString('en-us', options);
    const getDayToCheckPad = retDate.split(' ');
    let val;
    if (getDayToCheckPad[1].length == 2) {
      val = '' + getDayToCheckPad[0] + ' 0' + getDayToCheckPad[1] + ' ' + getDayToCheckPad[2] + '';
    } else {
      val = retDate;
    }
    return val;
  }

  function fixServiceMark() {
    const body = document.getElementById('postBody');
    // @ts-ignore
    const fixedBodyText = body.innerHTML.replaceAll('Line-of-SightSM','Line-of-Sight<sup>sm</sup>');
    // @ts-ignore
    body.innerHTML = fixedBodyText;
  }

  useEffect(() => {
    fixServiceMark();
  });

  return (
    <>
      <Nav />
      <main className="row main-blog-row">
        <Banner bannerHeading={''} bannerSubHeading={''} bannerImage={urlFor(blogPageContent[0].banner_image).width(1920).url()} />
        <div className="col-12">
          <div className="container post-container">
            <div className="row post-row">
              <div className="col-12 col-sm-9 post-col">
                <div className="title title-font">
                  {post.title}
                </div>
                <div className="details regular-font">
                  {post.category != '' ?
                    <><span className="category">{post.category}</span> <i className="fa fa-circle"></i></>
                    :
                    ''
                  }
                  {post.date} <i className="fa fa-circle"></i> 
                  {post.author}
                </div>

                <div className="banner">
                  <img src={urlFor(post.post_image).width(1200).url()} />
                </div>

                <div id="postBody" className="body regular-font" dangerouslySetInnerHTML={{__html: toHTML(post.body)}}>
                  {/* */}
                </div>
              </div>
              <FeaturedPosts featuredPosts={featuredPosts} />
            </div>
          </div>
        </div>
        <ContactForm adminEmails={siteSettings[0].admin_emails} />
      </main>
      <Footer />
    </>
  )
}
// @ts-ignore
export async function getServerSideProps(context) {
  // It's important to default the url_path so that it doesn't return "undefined"
  const { url_path = "" } = context.params
  const blogPageContent = await client.fetch(groq`*[_type == "blogPage"]`);
  const post = await client.fetch(`*[_type == "post" && url_path == $url_path][0]`, { url_path });
  // Now we need to search for all posts with matching tags and not matching the current url_path
  // const relatedPosts = await client.fetch(`*[_type == "post" && url_path == $url_path][0] {
  //   title,
  //   tags[]->,
  //   "related": *[_type == "post" && url_path != $url_path && count(tags[@.value in ^.^.tags[].value]) > 0] |  order(_createdAt desc) [0..1]
  // }`, { url_path });
  const featuredPosts = await client.fetch(`*[_type == "post" && featured_post == true] | order(title asc)`);
  const siteSettings = await client.fetch(groq`*[_type == "siteSettings"]`);
  return {
    props: {
      blogPageContent: blogPageContent,
      post: post,
      featuredPosts:featuredPosts,
      siteSettings: siteSettings
    }
  }
}
